export class SemaphoreService {

    public static IsWorking : boolean;

	/**
	 * Execute a promise one at a time in order.
	 * @param newWork Promise to enqueue.
	 */
    public static async ExecuteRequestAsync(newWork: ()=>Promise<void>): Promise<void> {        

		if (SemaphoreService.IsWorking){
			await SemaphoreService.WaitForQueueAsync();
		}

		SemaphoreService.IsWorking = true;

		if (newWork){
			await newWork();
		}

		SemaphoreService.IsWorking = false;
    }	

	private static InternalWaitForSearch(resolveCallback: any) {        
            if (!SemaphoreService.IsWorking) {
                if (resolveCallback) {
                    resolveCallback();
                }
            } else {
                setTimeout(() => {
                    SemaphoreService.InternalWaitForSearch(resolveCallback);
                }, 200);
            }        
    }	

	private static WaitForQueueAsync(): Promise<void> {        
        return new Promise<void>(
            (resolve, reject) => {
				try {					
					SemaphoreService.InternalWaitForSearch(resolve);
				} catch (error) {
					reject(error);
				}
            });
    }	 	
}